$(document).ready(function() {

    /* VERANSTALTUNGSLISTE */
    // Sprache für den Datepicker dynamisch setzen
    var siteLanguage = $('html').attr('lang');

    /* VERANSTALTUNGSDETAILSEITE */
    $('.ttgVeranstaltungTermineButton').click(function() {
        $('#ttgAccVeranstaltungstermine').trigger('click');
        $('html, body').animate({
            scrollTop: ($('#ttgAccordionVeranstaltungstermine').offset().top)
        }, 500);
    });

    $('.ttgVeranstaltungOrteButton').click(function() {
        $('#ttgAccVeranstaltungsorte').trigger('click');
        $('html, body').animate({
            scrollTop: ($('#ttgAccVeranstaltungsorte').offset().top)
        }, 500);
    });


    // Veranstaltungstermine
    if ($(".ttgVeranstaltungsTermine > li").length > 10) {
        hideElements(
            ".ttgVeranstaltungsTermine",
            "li",
            10,
            $(".ttgVeranstaltungsTermine").data("show-more-text"),
            $(".ttgVeranstaltungsTermine").data("show-less-text")
        );
    }
});


function hideElements(container, element, number, moreLink, lessLink) {
    var elementsToHide = $(container + " > " + element + ":nth-child(" + number + ")").nextAll();
    console.log("%cTTG Debug", "background: #0080a3; color: #fff; padding: 5px;", $(container));
    var fullHeight = $(container).get(0).scrollHeight; // save height of all accordions/default-State
    elementsToHide.hide();
    var hiddenHeight = $(container).get(0).scrollHeight; // save height after accordions have been hidden
    $(container).after('<div><a class="ttgMoreLink" href="#">' + moreLink + '</a></div>');
    $(container).attr("aria-expanded", "false");
    var newHeight = $(container).get(0).scrollHeight;

    $(".ttgMoreLink").click(function(e) {
        e.preventDefault();
        newHeight = $(container).get(0).scrollHeight;
        $(container).height(newHeight); // current height of visible accordions
        if ($(container).attr("aria-expanded") == 'false') {
            elementsToHide.show();
            $(container).height(fullHeight + (newHeight - hiddenHeight)); // get height (calculate if accordions have been opened/closed and adjust accordingly) and open
            $(".ttgMoreLink").text(lessLink);
            $(container).height(''); // revert to CSS-set height
            $(container).attr("aria-expanded", "true");
        } else {
            $(container).height(hiddenHeight); // get height (calculate if accordions have been opened/closed and adjust accordingly) and open
            $(".ttgMoreLink").text(moreLink);
            $(container).height(''); // revert to CSS-set height
            $(container).attr("aria-expanded", "false");
            elementsToHide.hide();
        }
    });

}